import { colorsUtils } from '@/utils'

import { NearMeDisabled } from '@mui/icons-material'
import { Box, Stack } from '@mui/material'

import { Tooltip } from '@/components/primitives/Tooltip'

import VehicleColor from '../VehicleColor'

import { preview } from '@/components/form/preview'
import { useAssignmentsInfo } from './hooks/useAssignmentsInfo'
import { useTexts } from './hooks/useTexts'

interface Props {
  assignments: uui.domain.client.rm.DriverAssignments
}

export function ViewDetails(props: Props) {
  const { assignments } = props

  const assignmentsInfo = useAssignmentsInfo(assignments)
  const texts = useTexts()

  return (
    <>
      {assignmentsInfo.map(info => {
        const { driverLabel, driverId, id, vehicleLabel, hasDevice, color } = info

        return (
          <Stack direction="column" key={id} mb={3}>
            <preview.Field
              label={
                <Stack direction="row" alignItems="center" spacing={0.5}>
                  <Box display="flex" alignItems="center">
                    <VehicleColor size={12} color={colorsUtils.getValidHexColor(color)} />
                  </Box>
                  <Box component="span" display="flex" alignItems="center" lineHeight={1}>
                    {vehicleLabel}
                  </Box>

                  {!hasDevice && (
                    <Tooltip title={texts.notTracked} placement="bottom">
                      <Box display="flex" alignItems="center">
                        <NearMeDisabled
                          sx={{
                            fontSize: 16,
                          }}
                        />
                      </Box>
                    </Tooltip>
                  )}
                </Stack>
              }
              testId="check-in"
            >
              {driverId ? driverLabel : '-'}
            </preview.Field>
          </Stack>
        )
      })}
    </>
  )
}
